<template>
  <transition name="fade">
    <div v-if="shouldDisplay" class="documents-need-add-all-added" @click="closeAction">
      <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
          fill="#12C971"
        />
        <path
          d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
          fill="#12C971"
        />
      </svg>
      <div class="documents-need-add-all-added-message">
        <div class="documents-need-add-all-added-message-text">{{ message }}</div>
        <button class="documents-need-add-all-added-message-close" @click="closeAction">Закрыть</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "all-documents-added-success-message",
  props: {
    shouldDisplay: {
      type: Boolean,
      default: () => false,
    },
    message: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    closeAction() {
      this.$emit("close-action");
    },
  },
};
</script>

<style lang="scss" scoped>
.documents-need-add-all-added {
  margin-top: 8px;
  background: #d0f4e3;
  display: flex;
  align-items: flex-start;
  border-radius: 6px;
  height: auto;
  width: 100%;
  padding: 22px 21px 22px 27px;

  @media screen and (max-width: 1024px) {
    height: auto;
    align-items: center;
  }

  @media screen and (max-width: 450px) {
    height: 85px;
    padding: 20px;
    margin-left: -20px;
    width: calc(100% + 40px);
    border-radius: 0;
    align-items: flex-start;
  }

  & svg {
    margin-top: 3px;
    width: 14px !important;
    min-width: 14px !important;
    height: 10px !important;
    min-height: 10px !important;

    @media screen and (max-width: 1024px) {
      margin-top: 0;
    }

    @media screen and (max-width: 450px) {
      margin-top: 3px;
    }
  }

  &-message {
    margin-left: 12.5px;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1024px) {
      flex-direction: row;
    }

    @media screen and (max-width: 450px) {
      max-width: 245px;
      flex-direction: column;
    }

    &-text {
      font-size: 13px;
      line-height: 120%;
    }

    &-close {
      border: none;
      font-size: 13px;
      line-height: 120%;
      padding: 0;
      margin: 8px 0 0 0;
      color: #0066ff;
      width: 51px;
      background: transparent;

      &:focus {
        outline: none;
      }

      @media screen and (max-width: 1024px) {
        margin: 0 0 0 12.5px;
      }

      @media screen and (max-width: 450px) {
        margin: 8px 0 0 0;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
